import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableRow from "./TableRow"

class TableBody extends Component {
    _renderTableContent = () => {
        const {items, refreshList, arrSelected, onSelected} = this.props

        if (items.length === 0) {
            return <tr>
                <td colSpan={13}>Không có dữ liệu.</td>
            </tr>
        }

        return items.length > 0 && items.map((item) => {
            return <TableRow key={item._id} item={item} refreshList={refreshList} arrSelected={arrSelected}
                             onSelected={onSelected}/>
        })
    }

    render() {
        return (
            <tbody className="TableBody">
            {this._renderTableContent()}
            </tbody>
        )
    }
}

TableBody.propTypes = {
    refreshList: PropTypes.func.isRequired,
    items: PropTypes.array,
    loading: PropTypes.bool,
}

export default TableBody